import React from 'react'
import PropTypes from 'prop-types'

const ThankYou = ({ onBackToForm, registrationCode }) => {
  return (
    <div className="text-center py-12">
      {/* Icon */}
      <div className="mb-8">
        <div className="w-24 h-24 bg-blue-100 rounded-full flex items-center justify-center mx-auto">
          <svg className="w-12 h-12 text-blue-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z" />
          </svg>
        </div>
      </div>

      {/* Message */}
      <div className="mb-8">
        <h2 className="text-3xl font-bold text-gray-800 mb-4">
          Registration Received
        </h2>
        <div className="text-lg text-gray-600 space-y-3 max-w-2xl mx-auto">
          <p>
            Thank you for registering your interest. Your details have been saved
            and we will contact you by email with details as they become available.
          </p>
        </div>
      </div>

      {/* Registration Code */}
      {registrationCode && (
        <div className="bg-green-50 border border-green-200 rounded-lg p-6 mb-8 max-w-md mx-auto">
          <h4 className="text-lg font-semibold text-green-800 mb-2">Your Registration Code:</h4>
          <div className="text-2xl font-mono font-bold text-green-900 bg-white rounded p-3 border">
            {registrationCode}
          </div>
          <p className="text-sm text-green-700 mt-2">
            Please save this code for your records and reference in all communications.
          </p>
        </div>
      )}

      {/* Contact Information */}
      <div className="bg-gray-50 rounded-lg p-6 mb-8 max-w-2xl mx-auto">
        <h3 className="text-xl font-semibold text-gray-800 mb-4">Need Help?</h3>
        <div className="text-gray-600 space-y-2">
          <p>
            If you have any questions, please contact us:
          </p>
          <div className="space-y-1">
            <p>
              <strong>Email:</strong>{' '}
              <a
                href="mailto:flights@igudys.com"
                className="text-blue-600 hover:text-blue-800 underline"
              >
                flights@igudys.com
              </a>
            </p>
          </div>
        </div>
      </div>

      {/* Action Buttons */}
      <div className="space-y-4">
        {onBackToForm && (
          <button
            onClick={onBackToForm}
            className="themed-button-secondary mx-2"
          >
            Submit Another Registration
          </button>
        )}
      </div>
    </div>
  )
}

ThankYou.propTypes = {
  onBackToForm: PropTypes.func,
  registrationCode: PropTypes.string
}

export default ThankYou